var Literals = /** @class */ (function () {
    function Literals() {
    }
    Literals.SCENARIO = "scenario";
    Literals.STEP = "step";
    Literals.FEATURE = "feature";
    Literals.SUITE = "suite";
    Literals.NONE = "none";
    Literals.error = "error";
    Literals.Error = "Error";
    Literals.dataSetDoesNotExists = "Dataset does not exists or Deleted";
    Literals.errorInDownloadingDataset = "Error in downloading dataset";
    Literals.logDoesNotExists = "Log does not exists";
    Literals.errorInDownloadingLogs = "Error in downloading log";
    Literals.errorInGeneratingUrl = "Error in generating url";
    Literals.Completed = "Completed";
    Literals.Failed = "Failed";
    Literals.executionFailed = "Execution Failed";
    Literals.STEPEXECUTION = "stepexecution";
    Literals.video = "video";
    Literals.EXECUTE_FRAMEWORK = "EXECUTE_FRAMEWORK";
    Literals.text = "text";
    Literals.blank = "_blank";
    Literals.db1 = "db1";
    Literals.ide = "ide";
    Literals.db2 = "db2";
    Literals.ERROR = "ERROR";
    Literals.GITHUB_REAUTH_REQUIRED = "GITHUB_REAUTH_REQUIRED";
    Literals.EXECUTION_QUOTA_AVAILABLE = "executionQuotaAvailable";
    Literals.CANVAS = "CANVAS";
    Literals.CAPITAL_SUCCESS = "SUCCESS";
    Literals.SMALL_SUCCESS = "success";
    Literals.Warning = "Warning";
    Literals.Success = "Success";
    Literals.projectId = "projectId";
    Literals.GENERATING_CODE = "GENERATING_CODE";
    Literals.STITCH_FRAMEWORK = "STITCH_FRAMEWORK";
    Literals.DEPLOY_FRAMEWORK = "DEPLOY_FRAMEWORK";
    Literals.STATISTIC = "statistic";
    Literals.SCHEDULE = "schedule";
    // Gesture Literals
    Literals.TAP = "tap";
    Literals.DOUBLE_TAP = "doubletap";
    Literals.LONG_PRESS = "longpress";
    Literals.SWIPE = "swipe";
    Literals.TYPE = "type";
    Literals.ZOOM_IN = "zoom-in";
    Literals.ZOOM_OUT = "zoom-out";
    Literals.TWO_FINGER_SWIPE = "twofinger-swipe";
    Literals.THREE_FINGER_SWIPE = "threefinger-swipe";
    Literals.PRESS_HOME = "press-home";
    Literals.PRESS_BACK = "press-back";
    Literals.PRESS_RECENTS = "press-recents";
    Literals.PRESS_VOLUME_UP = "press-volumeup";
    Literals.PRESS_VOLUME_DOWN = "press-volumedown";
    Literals.PRESS_POWER = "press-power";
    Literals.KEYBOARD_ACTION = "keyboard-action";
    Literals.GET_TEXT = "get-text";
    Literals.TAP_AND_TYPE = "tap and type";
    Literals.SLIDER = "slider";
    //scheduler literals
    Literals.SUITE_NAME = "suiteName";
    return Literals;
}());
export { Literals };
//# sourceMappingURL=literals.js.map